// extracted by mini-css-extract-plugin
export default {"container":"edit-contact-modal_container__jnVsr","title":"edit-contact-modal_title__2g-0j"};